/**
 * Shell for the Audit section (activity log + invoice anomalies).
 *
 * Same outer chrome (sidebar, header) as every other page via the
 * shared ``Layout`` component, plus a two-tab strip that lets admins
 * move between the activity log and the anomaly feed without having
 * to navigate back through the sidebar.
 */
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { Layout } from '@/components/common/Layout/Layout'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'

const TABS = [
  { value: 'activity', label: 'Activity log', path: '/audit/activity' },
  { value: 'anomalies', label: 'Anomalies', path: '/audit/anomalies' },
] as const

type TabValue = (typeof TABS)[number]['value']

export default function AuditLayout() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const active: TabValue = pathname.startsWith('/audit/anomalies') ? 'anomalies' : 'activity'

  const handleChange = (value: string) => {
    const next = TABS.find((t) => t.value === value)
    if (next && next.path !== pathname) navigate(next.path)
  }

  return (
    <Layout>
      <div className="mb-4">
        <Tabs value={active} onValueChange={handleChange}>
          <TabsList>
            {TABS.map((t) => (
              <TabsTrigger key={t.value} value={t.value}>
                {t.label}
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>
      </div>
      <Outlet />
    </Layout>
  )
}
